import { CommandsBase } from './base';

export namespace Statistics {
  export namespace Types {
    export interface StatPoint {
      timestamp: string;
      count: number;
      boardId?: number;
    }
    export type StatPointList = StatPoint[];
    export interface StatCountValue {
      count: number;
    }
    export interface StatIncrementValue {
      value: number;
      boardId?: number;
    }
    export interface StatDataSet {
      validationSuccess: StatPointList;
      validationFailures: StatPointList;
      deliveredPostings: StatPointList;
      deliveredNewPostings: StatPointList;
      deliveryFailures: StatCountValue;
      inProcessPostings: StatPointList;
    }
    export interface StatChartPeriod {
      label: string;
      value: string;
    }
    export interface PendingPostings {
      url: string;
      count: number;
    }
    export type GroupType = 'deliver' | 'validate' | 'inProcess';
    export type PeriodType = 'lastDay' | 'lastWeek' | 'lastMonth';

    export interface DistributionStatisticsProps {
      period: PeriodType;
    }

    export interface BoardStatisticsProps {
      boardId: number;
      period: PeriodType;
    }
  }

  export const PERIODS = {
    DAY: {
      label: 'Today',
      value: 'lastDay',
    },
    WEEK: {
      label: 'Week',
      value: 'lastWeek',
    },
    MONTH: {
      label: 'Month',
      value: 'lastMonth',
    },
  };

  export const GROUPS = ['deliver', 'validate', 'inProcess'];

  export const StatListToSeriesLine = (data: Types.StatPointList) => {
    return data.map((el) => ({ x: el.timestamp, y: el.count }));
  };

  export const SERVICE = 'statistics';

  export const ACTIONS = {
    board: 'board',
    distribution: 'distribution',
  };

  export const EVENTS = {
    addDeliveryFailures: 'addDeliveryFailures',
    addDeliveredNewPostings: 'addDeliveredNewPostings',
    addDeliveredPostings: 'addDeliveredPostings',
    addValidationFailures: 'addValidationFailures',
    addValidationSuccess: 'addValidationSuccess',
    addInProcessPostings: 'addInProcessPostings',
  };

  export class Commands extends CommandsBase {
    // todo: rename service\action to 'statistics/distribution' (amd fix api)
    loadStatistics(props: Types.DistributionStatisticsProps) {
      return Promise.all(
        Statistics.GROUPS.map((group) =>
          this.client.execute(this.command(ACTIONS.distribution), {
            ...props,
            group,
          })
        )
      );
    }

    // todo: rename service\action to 'statistics/board' (amd fix api)
    getBoardStatistics(props: Types.BoardStatisticsProps) {
      return Promise.all(
        Statistics.GROUPS.map((group) =>
          this.client.execute(this.command(ACTIONS.board), {
            ...props,
            group,
          })
        )
      );
    }
  }
}
